export const CLASS_KEYS = Object.freeze([
    "Root",
    "Document",
    "Mapping",
    "Sequence",
    "Scalar",
    "Reference"
]);
